import { render, staticRenderFns } from "./defaultScroll.vue?vue&type=template&id=71750db8&scoped=true&"
import script from "./defaultScroll.vue?vue&type=script&lang=js&"
export * from "./defaultScroll.vue?vue&type=script&lang=js&"
import style0 from "./defaultScroll.vue?vue&type=style&index=0&id=71750db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71750db8",
  null
  
)

export default component.exports